export const GAME_STAGES = {
  WAITING: "waiting",
  READY: "ready",
  PAUSE: "pause",
  WAITING_FOR_DESCRIBER: "waiting_for_describer",
  WAITING_FOR_GUESSER: "waiting_for_guesser",
  RESULTS: "results",
};

export const DEFAULT_ROOM = new URLSearchParams(window.location.search).get("room") || "room";
export const HOME_PATH = DEFAULT_ROOM !== "room" ? `/?room=${DEFAULT_ROOM}` : "/";

export const PLAYER_ROLES = {
  DESCRIBER: "describer",
  GUESSER: "guesser",
};
